import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import refPropType from './refPropTypes';

import NumberInput from './NumberInput';

import style from './Input.module.scss';

export default function Input({ className, type, inputRef, ...otherProps }) {
  const InputComponent = {
    text: 'input',
    password: 'input',
    textarea: 'textarea',
    number: NumberInput,
  }[type];
  // NumberInput handles inputRef => ref internally:
  const ref = type === 'number' ? null : inputRef;

  return (
    <InputComponent
      className={classnames(style.input, className)}
      type={type}
      ref={ref}
      {...otherProps}
    />
  );
}

Input.displayName = 'Input';
Input.propTypes = {
  /**
   * class name to pass into input
   */
  className: PropTypes.string,
  /**
   * an html `input` type attribute
   */
  type: PropTypes.oneOf(['text', 'textarea', 'number', 'password']),
  /**
   * reference to underlying `input` dom element
   */
  inputRef: refPropType,
};

Input.defaultProps = {
  className: '',
  type: 'text',
  inputRef: null,
};
